//描述：敏感词注入模块专用模块
//作者：BaiZhiming
//时间：2016-12-7
"use strict";
angular.module("sensitiveWordImportModule",[
		"sensitiveWordCheckServiceModule",
		"sensitiveInputModule",
		"markSensitiveWordCompareModule"
	]);